"use strict";

/**
 * @classdesc
 * Öffnet einen externen Link.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.action
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {string} options.url Link der aufgerufen werden soll
 * @param {string} [options.target="_blank"] optionales Linkziel
 * @param {bool} [options.isModal=false] optionales Flag, ob der Link innerhalb eines Modalen Dialogs aufgerufen werden soll.
 */
gc.gis.action.GCOpenLink = function(options)
{
	gc.gis.action.GCAbstractAction.call(this);

	this.func = this.doExecute;
	this.args = [options.url, options.target || "_blank", options.isModal];
};
gc.gis.action.GCOpenLink.prototype = Object.create(gc.gis.action.GCAbstractAction.prototype);

/**
 * Öffnet den externen Link gemäß den angegebenen Optionen.
 *
 * @param {string} url
 * @param {string} [target]
 * @param {bool} [isModal]
 */
gc.gis.action.GCOpenLink.prototype.doExecute = function(url, target, isModal)
{
	window.open(url, target);

	if (isModal)
	{
		// TODO
	}
};
